<template>
  <div class="test-container">
    <div class="test-bg" v-if="!showList.length">
      <img src="../images/no_data.png" alt="">
      <span> 暂无数据～</span>
    </div>
    <div class="test-item" v-else v-for="(item,index) in showList" :key="index">
      <div class="test-title">
        <div class="test-subject math" v-if="item.subject_id===2">
         数</div>
            <div class="test-subject physics" v-else-if="item.subject_id===1">
         英</div>
          <div class="test-subject math" v-else-if="item.subject_id===3">
         语</div>
           <div class="test-subject chemistry"  v-else-if="item.subject_id===900">
         化</div>
          <div class="test-subject physics" v-else-if="item.subject_id===4">
         物</div>
        <div class="test-section">{{item.evaluate_name}}</div>
      </div>
      <div class="test-foot">
        <div class="test-time">
          <span>发布时间 {{item.created}}</span>
        </div>
        <button class="test-button" @click="testStart(item)">立即测试</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getSign } from '@/pages/dl-web/utils/verify'
import api from '@/pages/dl-web/api/api'
import moment from 'moment';
import { openTab } from '@/utils';

export default {
  name:'UnfinishedList',
  data() {
    return {
      params: {},
    };
  },
  props: {
    activeId: {
      default: '0',
      type: String,
    },
    unfinishedList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    showList() {
      if (this.activeId === '0') {
        return this.unfinishedList;
      }
      return this.unfinishedList.filter((item) => item.subject_id.toString() === this.activeId);
    },
  },
  filters: {
    formatTime(val) {
      return moment(val).format('MM-DD HH:mm')
    },
  },
  methods: {
    async testStart(item) {
      const parms = {
        evaluate_id:item.evaluate_id,
        class_id:item. class_id,
        subject_id: item.subject_id,
        version_id: item.textbook_id,
        grade_id: item.test_grade_id,
        user_grade_id:item.grade_id,
        test_id: item.test_id,
        question_level: item.dl_question_level,
        time_stamp: (new Date()).getTime(),
        kmap_code: item.dl_kmap_code,
        code: item.dl_code,
        status: item.dl_status,

      };
      parms.sign = getSign(parms);
      const res = await api.testStart(parms);
      console.log(res)
      if (res) {
        if (res.code === 1002) {
          this.$toast('做题记录已存在，去报告页');
          // 做题记录已存在，去报告页
          setTimeout(() => {
            this.$router.push({
              path: '/dl-web/question/report',
              query: {
                id: res.data.tsid,
                schoolId:localStorage.getItem('school_id')||'',
              },
            });
          }, 1500);
        } else if (res.code === 0 || res.code === 1003) {
          this.$toast(res.msg);
            // 从新开一个页面
            const url = `${window.location.protocol}//${window.location.host}/dl-web/do/question?id=${res.data.tsid}&courseType=${res.data.course_type}`;
            openTab(url);
        } else {
          window.gio('track', 'startTest', { result: 'fail', fail_reason: res.msg || '未知原因' });
          this.$toast(res.msg);
        }
      } else {
        this.$toast('网络错误，请刷新');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.test-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .test-bg{
    margin: 86px auto;
    position: relative;
    img{
      display: block;
    }
    span{
      position: absolute;
      left: 50%;
      transform: translate(-50%,12px);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(17, 31, 44, 0.6);
    }
  }
  .test-item {
    box-sizing: border-box;
    width: 492px;
    height: 125px;
    background: url("../images/test-bg.png") no-repeat;
    padding: 25px;
    margin-bottom: 18px;
    .test-title {
      font-size: 14px;
      font-weight: 550;
      display: flex;
      margin-bottom: 18px;
      .test-subject {
        width: 24px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        background: #0dd4c8;
        border-radius: 6px;
        margin-right: 8px;
        color:#FFFFFF
      }
      .test-section {
        width: 340px;
        height: 22px;
        font-size: 16px;
        font-weight: 500;
        color: #111f2c;
        line-height: 22px;
        letter-spacing: 1px;
      }
      .math{
      background-color: #0DD4C8;
      }
      .physics{
        background-color: #27ACFF;
      }
      .chemistry{
        background-color: #9962F8;
      }

    }
    .test-foot {
        display: flex;
        justify-content: space-between;
          font-size: 14px;
        .test-time {
          // font-weight: 400;
          color: rgba(17, 31, 44, 0.6);
          line-height: 20px;
          margin-top:8px ;
        }
        .test-button {
          font-weight: 500;
          color: #FFFFFF;
          width: 100px;
          height: 30px;
          background: #2194FF;
          box-shadow: 0px 3px 5px 0px rgba(33, 148, 255, 0.4);
          border-radius: 16px;
          margin-right: 2px;
          cursor: pointer;
        }
      }
  }
}
</style>
